// Default commission rates applied when an affiliate has no per-product
// override set (see the admin "Taxas de afiliado" section on AdminUsers.tsx
// and the pre-load fallback on AffiliatesPage.tsx). This is the single
// frontend source of truth for these numbers — never re-literal them.
export const AFFILIATE_DEFAULT_RATES = {
  payment: 20,
  course: 50,
  cpm: 2,
} as const;

/**
 * Parses a single rate input field.
 *
 * Blank/whitespace-only input means "cleared" — the affiliate inherits the
 * platform default for that product. `0` is a deliberate, real override
 * meaning no commission on that product; it must never be conflated with
 * "cleared". Anything else that isn't an integer 0–100 is invalid.
 */
export function parseAffiliateRateField(raw: string): number | null | undefined {
  const trimmed = raw.trim();
  if (trimmed === "") return null; // cleared -> inherit the default
  const value = Number(trimmed);
  if (!Number.isInteger(value) || value < 0 || value > 100) return undefined; // invalid
  return value;
}
